import { motion } from 'framer-motion';
import { useState } from 'react';
import Button from '../UI/Button';

const healthOptions = [
  {
    id: 'excellent',
    label: 'Excellent - I feel great most days'
  },
  {
    id: 'good',
    label: 'Good - Generally healthy with minor issues'
  },
  {
    id: 'fair',
    label: 'Fair - Some health challenges'
  },
  {
    id: 'poor',
    label: 'Poor - Struggling with health issues'
  }
];

export default function HealthRatingScreen({ onContinue }) {
  const [selectedHealth, setSelectedHealth] = useState(null);

  const handleSelect = (optionId) => {
    setSelectedHealth(optionId);
  };

  const handleContinue = () => {
    if (selectedHealth) {
      onContinue();
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-2xl mx-auto"
    >
        <div className="bg-white rounded-luxury shadow-luxury p-8">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal text-center mb-4">
            How would you rate your <span className="text-renuvia-gold">overall health</span>?
          </h2>

          <p className="text-slate text-center mb-8 text-lg">
            This helps us understand where you're starting from.
          </p>

          <div className="space-y-4 mb-8">
            {healthOptions.map((option, index) => (
              <motion.button
                key={option.id}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                onClick={() => handleSelect(option.id)}
                className={`w-full p-5 rounded-xl border-2 transition-all text-left flex items-center gap-4 ${
                  selectedHealth === option.id
                    ? 'border-renuvia-gold bg-renuvia-gold bg-opacity-5'
                    : 'border-gray-200 hover:border-renuvia-gold hover:bg-warm-beige'
                }`}
              >
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                  selectedHealth === option.id
                    ? 'border-renuvia-gold'
                    : 'border-gray-300'
                }`}>
                  {selectedHealth === option.id && (
                    <div className="w-3 h-3 rounded-full bg-renuvia-gold"></div>
                  )}
                </div>
                <span className="text-charcoal text-lg">{option.label}</span>
              </motion.button>
            ))}
          </div>

        <Button
          onClick={handleContinue}
          fullWidth
          disabled={!selectedHealth}
        >
          Continue →
        </Button>
      </div>
    </motion.div>
  );
}
